import React from "react";

import "./index.css";
import { BsyUtils } from "../../utils/Utils";
import BsySelect from "../BsySelect";
import BsyTextEditor from "../BsyTextEditor";

class BsyComboBox extends BsySelect {
  constructor(props) {
    super({
      baseCls: "BsyComboBox",
      textField: "text",
      valueField: "value",
      hasSelectEmpty: false,
      asyncResultKey: "items",
      type: "combo",
      ...props,
    });
  }

  setValue = (value) => {
    this.value = value;
    this.setState({
      value: value,
      items: this.filterData(),
    });
  };

  showItem = () => {
    const { textField, valueField, subform } = this.options;
    const { items } = this.state;
    const { value } = this.state;
    let text = [];

    items &&
      items.map((val) => {
        if (val[valueField] === value)
          !BsyUtils.isObjectEmpty(val[valueField]) && (text = val[textField]);
      });

    if (this.selectOther) {
      if (!subform) {
        text = [this.otherItem[textField]];
      } else {
        text = [this.otherText];
      }
    } else {
      if (BsyUtils.isObjectEmpty(text)) {
        if (value == "fx_param_empty") {
          text = this.options.emptySelectText;
        } else {
          if (BsyUtils.isObjectEmpty(value)) {
            text = "";
          } else {
            text = [value];
          }
        }
      }
    }
    return text;
  };

  selectItem = (val) => {
    const { listLimitChange, valueField } = this.props;
    this.selectItems = [val];
    this.isEditd = this.state.value !== val[valueField];
    if (val.isOther) {
      this.selectOther = true;
      this.otherItem = val;
    } else {
      this.selectOther = false;
    }
    this.value = this.selectOther
      ? this.otherText
      : BsyUtils.isObjectEmpty(val[valueField])
      ? null
      : val[valueField];
    this.setState({ value: val[valueField], showList: false }, () => {
      listLimitChange && listLimitChange(val[valueField]);

      if (this.selectOther === true) {
      } else {
        if (this.props.onStopEdit) {
          this.props.onStopEdit(this.value, null, this);
        }
      }
    });
  };

  getValue = () => {
    if (this.selectOther) {
      return this.otherText;
    } else {
      return this.value;
    }
  };

  checkValidate = () => {
    var a = this.options,
      b = !0;
    this.setInvalidateTypeText("");
    if (!a.allowBlank) {
      if (this.selectOther) {
        b = !BsyUtils.isObjectEmpty(this.otherText);
      } else {
        b = !BsyUtils.isObjectEmpty(this.value);
      }
    }

    if (!b) {
      this.setInvalidateTypeText(React.language("item.required"));
    }
    return b;
  };

  findSelectItem = (val) => {
    const { items } = this.state;
    const { valueField } = this.options;
    this.selectItems = [];
    if (!val || val.length === 0) return;
    if (!items) {
      return;
    }
    this.selectItems = items.filter((e) => {
      return val.indexOf(e[valueField]) > -1;
    });
  };

  renderDisablePane = (text) => {
    const { colorEnable } = this.options;
    const { valueField } = this.options;
    return (
      <div
        className="bsy_form_item_disable"
        data-watermark={React.language("content.empty")}
        ref={this.element}
      >
        {this.renderColorEnableItems(text)}
      </div>
    );
  };

  renderColorEnableItems = (text) => {
    const { colorEnable, waterMark, hint, subform, textField } = this.options;
    const { value } = this.state;
    if (!colorEnable) {
      if (this.selectOther) {
        if (subform) {
          return (
            <span className="value-text" data-watermark={waterMark || hint}>
              {this.otherText}
            </span>
          );
        }

        if (!this.isEnabled()) {
          return (
            <span className="value-text" data-watermark={waterMark || hint}>
              {this.otherText}
            </span>
          );
        }
        return (
          <span className="value-text" data-watermark={waterMark || hint}>
            {this.otherItem.text}
          </span>
        );
      }

      return (
        <span className="value-text" data-watermark={waterMark || hint}>
          {text}
        </span>
      );
    }

    var showItems = this.selectItems.filter((item) => {
      return value === item.value;
    });
    if (showItems.length) {
      var e = showItems[0];
      if (e.color) {
        return (
          <span
            className={"  bsy-text-tag  middle multi-line  "}
            data-watermark={waterMark || hint}
            style={{
              background: e && e.color,
              color: "#fff",
              border: "1px solid " + e && e.color,
            }}
          >
            {e[textField]}
          </span>
        );
      }
      return (
        <span
          className={" bsy-text-tag  middle multi-line  "}
          data-watermark={waterMark || hint}
          style={{
            background: "#e0e0e0",
            color: "#333",
            border: "1px solid var(--bsy-base-border-color) ",
          }}
        >
          {e[textField]}
        </span>
      );
    }
    if (this.selectOther) {
      if (subform) {
        return (
          <span
            className={" bsy-text-tag  middle multi-line  "}
            data-watermark={waterMark || hint}
            style={{
              background: "#e0e0e0",
              color: "#333",
              border: "1px solid var(--bsy-base-border-color) ",
            }}
          >
            {this.otherText}
          </span>
        );
      }

      if (!this.otherText) {
        return (
          <span
            className={" bsy-text-tag  middle multi-line  "}
            data-watermark={waterMark || hint}
          ></span>
        );
      }
      if (!this.isEnabled()) {
        return (
          <span
            className={" bsy-text-tag  middle multi-line  "}
            data-watermark={waterMark || hint}
            style={{
              background: "#e0e0e0",
              color: "#333",
              border: "1px solid var(--bsy-base-border-color) ",
            }}
          >
            {this.otherText}
          </span>
        );
      }
      return (
        <span
          className={" bsy-text-tag  middle multi-line  "}
          data-watermark={waterMark || hint}
          style={{
            background: "#e0e0e0",
            color: "#333",
            border: "1px solid var(--bsy-base-border-color) ",
          }}
        >
          {this.otherItem.text}
        </span>
      );
    }
    return (
      <span className="value-text" data-watermark={waterMark || hint}></span>
    );
  };

  render() {
    const { minWidth, cssName, css, colorEnable, subform } = this.options;
    const { showList } = this.state;

    let text = this.showItem();
    if (colorEnable) this.findSelectItem(text);

    text = Array.isArray(text) ? text.join("") : text;

    if (!this.isEnabled()) {
      return this.renderDisablePane(text);
    }

    return (
      <div
        className={
          cssName +
          " " +
          (showList ? "open" : "") +
          (!subform && (this.selectOther ? " has-other " : ""))
        }
        style={{
          minWidth: minWidth,
          ...css,
          height: this.hasSelectOther ? "auto" : css.height,
        }}
      >
        <div
          className="showText"
          onClick={this.autoSelectList}
          ref={this.element}
          style={{
            height: this.hasSelectOther ? css.height : "",
          }}
        >
          <div className="selectShowText">
            {this.renderColorEnableItems(text)}
          </div>

          <div className={"iconSelect " + (text ? "has-value" : "")}>
            <i
              className="icon-bsy-xiala"
              style={{
                transform: showList ? "rotateX(180deg)" : "",
              }}
            >
              {" "}
            </i>
            <i
              className="widget-icon icon-dingding-guide-close"
              onClick={this.clear}
            ></i>
          </div>
        </div>
        {!subform && this.selectOther && (
          <BsyTextEditor
            ref={this.otherTextRef}
            value={this.otherText}
            height={css.height}
            waterMark={React.language("content.type")}
            onStopEdit={(val) => {
              this.otherText = val;
              BsyUtils.applyFunc(
                this,
                this.props.onStopEdit,
                [val, null, this],
                !1
              );
            }}
          ></BsyTextEditor>
        )}
      </div>
    );
  }
}

export default BsyComboBox;
